import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { type HTMLAttributes, computed } from 'vue';
import {
  SwitchRoot,
  type SwitchRootEmits,
  type SwitchRootProps,
  SwitchThumb,
  useForwardPropsEmits,
} from 'radix-vue';
import { cn } from '@/lib/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'Switch',
  props: {
    defaultChecked: { type: Boolean },
    checked: { type: Boolean },
    disabled: { type: Boolean },
    required: { type: Boolean },
    name: {},
    id: {},
    value: {},
    asChild: { type: Boolean },
    as: {},
    class: {}
  },
  emits: ["update:checked"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props;

  return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps, emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SwitchRoot), _mergeProps(_unref(forwarded), {
    class: _unref(cn)(
      'peer inline-flex h-6 w-11 shrink-0 cursor-pointer  items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:opacity-85 data-[state=checked]:bg-blue-700 data-[state=unchecked]:bg-gray-500',
      props.class
    )
      
  }), {
    default: _withCtx(() => [
      _createVNode(_unref(SwitchThumb), {
        class: _normalizeClass(_unref(cn)(
      'pointer-events-none block h-5 w-5 rounded-full bg-slate-50 data-[state=checked]:bg-slate-50 shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0'
    )
      )
      }, null, 8, ["class"])
    ]),
    _: 1
  }, 16, ["class"]))
}
}

})